(() => {
  'use strict';

  // Native Shopify terms control provider/market eligibility and variant prices.
  // Do not show a per-item finance amount beside a multiple-item order subtotal.
  function syncPaymentTerms() {
    document.querySelectorAll('form[data-native-payment-terms]').forEach((form) => {
      const productInfo = form.closest('product-info');
      const quantityInput = productInfo?.querySelector('input[name="quantity"]');
      const quantity = Number(quantityInput?.value || 1);
      const variantInput = form.querySelector('input[name="id"]');
      const hideTerms = quantity !== 1 || !variantInput?.value ||
        Boolean(productInfo?.querySelector('[name="add"][disabled]'));
      if (form.hidden !== hideTerms) form.hidden = hideTerms;
    });
  }
  document.addEventListener('input', (event) => {
    if (event.target.name === 'quantity') syncPaymentTerms();
  });
  document.addEventListener('change', (event) => {
    if (event.target.name === 'quantity' || event.target.name === 'id') syncPaymentTerms();
  });
  document.addEventListener('product-info:loaded', syncPaymentTerms);
  document.addEventListener('shopify:section:load', syncPaymentTerms);
  new MutationObserver(syncPaymentTerms).observe(document.body, {
    subtree: true, attributes: true, attributeFilter: ['disabled'],
  });
  if (window.theme?.pubsub) {
    theme.pubsub.subscribe(theme.pubsub.PUB_SUB_EVENTS.variantChange, syncPaymentTerms);
    theme.pubsub.subscribe(theme.pubsub.PUB_SUB_EVENTS.quantityUpdate, syncPaymentTerms);
  }
  syncPaymentTerms();

  // Preserve every shared menu entry and use the existing drawer if it won't fit.
  let navigationFrame;
  function fitNavigation() {
    cancelAnimationFrame(navigationFrame);
    navigationFrame = requestAnimationFrame(() => {
      document.querySelectorAll('header.header').forEach((header) => {
        header.classList.remove('header--compact-menu');
        if (window.innerWidth < 1024) return;
        if (window.innerWidth < 1440) {
          header.classList.add('header--compact-menu');
          return;
        }
        const navigation = header.querySelector('.header__navigation');
        const menu = navigation?.querySelector('.list-menu');
        const logo = header.querySelector('.header__logo');
        const icons = header.querySelector('.header__icons--end');
        const style = getComputedStyle(header);
        const available = header.clientWidth - parseFloat(style.paddingLeft) - parseFloat(style.paddingRight);
        const required = (logo?.getBoundingClientRect().width || 0) +
          (icons?.getBoundingClientRect().width || 0) + (menu?.scrollWidth || 0) +
          (parseFloat(style.columnGap) || 0) * 2;
        if (menu && required > available - 4) {
          header.classList.add('header--compact-menu');
        }
      });
    });
  }
  window.addEventListener('resize', fitNavigation, {passive: true});
  window.addEventListener('load', fitNavigation, {once: true});
  document.addEventListener('shopify:section:load', fitNavigation);
  document.fonts?.ready.then(fitNavigation);
  fitNavigation();

  // Salesmartly's own iframe and widget IDs were verified in its public loader.
  // This affects only the current theme's DOM, not the application settings.
  const root = document.documentElement;
  let userOpened = false;
  let chatButton;
  let chatFrame;
  function syncChat() {
    const host = document.getElementById('ss-chat-p') || document.getElementById('s-chat-plugin');
    if (!host) return;
    if (!chatButton) {
      chatButton = document.createElement('button');
      chatButton.type = 'button';
      chatButton.className = 'part1-chat-toggle';
      chatButton.setAttribute('aria-controls', 'ss-chat-p');
      chatButton.addEventListener('click', () => {
        userOpened = !userOpened;
        syncChat();
      });
      const entry = document.createElement('div');
      entry.className = 'part1-chat-entry page-width';
      entry.append(chatButton);
      (document.querySelector('footer.footer-group') || document.body).append(entry);
    }
    const modalOpen = [...document.querySelectorAll('#MenuDrawer, [role="dialog"][aria-modal="true"]')]
      .some((modal) => !modal.hidden && modal.getAttribute('aria-hidden') !== 'true' && modal.getClientRects().length > 0);
    if (chatButton.hidden !== modalOpen) chatButton.hidden = modalOpen;
    const buttonText = userOpened ? 'Hide chat' : 'Open chat';
    if (chatButton.textContent !== buttonText) chatButton.textContent = buttonText;
    const expanded = String(userOpened && !modalOpen);
    if (chatButton.getAttribute('aria-expanded') !== expanded) chatButton.setAttribute('aria-expanded', expanded);
    root.classList.toggle('part1-chat-hidden', modalOpen || !userOpened);
    // Leave room for the existing mobile sticky purchase controls and preview bar.
    let clearance = window.innerWidth < 768 ? 80 : 0;
    // The preview toolbar can live inside a full-viewport iframe; its outer
    // rectangle then cannot be used as the visible toolbar's height.
    if (document.getElementById('PBarNextFrame') || document.getElementById('preview-bar-iframe')) {
      clearance = Math.max(clearance, window.innerWidth < 768 ? 110 : 76);
    }
    document.querySelectorAll('product-sticky-form, #preview-bar-iframe, #PBarNextFrame, #shopify-preview-bar').forEach((element) => {
      const rect = element.getBoundingClientRect();
      if (rect.height && rect.height < 220 && rect.top > window.innerHeight / 2 && rect.top < window.innerHeight && rect.bottom > 0) {
        clearance = Math.max(clearance, window.innerHeight - rect.top);
      }
    });
    const value = clearance + 'px';
    if (root.style.getPropertyValue('--part1-chat-clearance') !== value) root.style.setProperty('--part1-chat-clearance', value);
  }
  function scheduleChat() {
    if (chatFrame) return;
    chatFrame = requestAnimationFrame(() => {
      chatFrame = undefined;
      syncChat();
    });
  }
  new MutationObserver(scheduleChat).observe(document.body, {
    childList: true, subtree: true, attributes: true,
    attributeFilter: ['hidden', 'aria-hidden', 'class', 'style'],
  });
  window.addEventListener('resize', scheduleChat, {passive: true});
  window.addEventListener('scroll', scheduleChat, {passive: true});
  document.addEventListener('keydown', (event) => {
    if (event.key === 'Escape' && userOpened) {
      userOpened = false;
      scheduleChat();
      chatButton?.focus();
    }
  });
  scheduleChat();
})();
